import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { Props } from './GallectionsEmptyState';
import { AppState } from '../../../../../types/store';
import {
  isCurrentUserProfileOwner,
  getProfileOwnerUser,
} from '../../../../selectors/users';
import { getGallectionSectionType } from '../../../../selectors/gallectionSection';
import { contributeDeviation } from '../../../../actions/groups';
import { getCanSubmitToGallery } from '../../../../selectors/privs';

export type StateProps = Pick<
  Props,
  'isOwner' | 'gallectionType' | 'owner' | 'canSubmitDeviations'
>;
export type DispatchProps = Pick<Props, 'contributeDeviation'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  isOwner: isCurrentUserProfileOwner(state),
  gallectionType: getGallectionSectionType(state),
  owner: getProfileOwnerUser(state),
  canSubmitDeviations: getCanSubmitToGallery(state),
});
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  contributeDeviation,
};

export default connect(mapStateToProps, mapDispatchToProps);
